import { render, staticRenderFns } from "./addOrUpdate.vue?vue&type=template&id=7f2c8d78&scoped=true&"
import script from "./addOrUpdate.vue?vue&type=script&lang=js&"
export * from "./addOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./addOrUpdate.vue?vue&type=style&index=0&id=7f2c8d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2c8d78",
  null
  
)

export default component.exports